export enum IndicatorTrendRAGs {
  Grey = 0,
  Red = 1,
  Amber = 2,
  Green = 3,
  Blue = 4,
}
